export const CURRENCIES = [
  { code: "IDR", symbol: "Rp", decimals: 0, name: "Rupiah", isBase: true },
  { code: "USDT", symbol: "₮", decimals: 2, name: "Tether USD" },
  { code: "USD", symbol: "$", decimals: 2, name: "US Dollar" },
  { code: "MYR", symbol: "RM", decimals: 2, name: "Ringgit" },
  { code: "CNY", symbol: "¥", decimals: 2, name: "Yuan" },
  { code: "KHR", symbol: "៛", decimals: 0, name: "Riel" },
];

export const PRODUCTS = [
  { code: "PULSA", symbol: "PLS", decimals: 0, name: "Pulsa" },
  { code: "TELE", symbol: "TG", decimals: 0, name: "Telegram Premium" },
];

const ALL = [...CURRENCIES, ...PRODUCTS];

export const curOf = (c) => ALL.find((x) => x.code === c) || { symbol: "", decimals: 2 };

export function fmtNum(amount, code = "IDR") {
  const c = curOf(code);
  const n = Number(amount || 0);
  return n.toLocaleString("id-ID", { minimumFractionDigits: c.decimals, maximumFractionDigits: c.decimals });
}

export function fmt(amount, code = "IDR") {
  return `${curOf(code).symbol} ${fmtNum(amount, code)}`;
}

export function fmtIDR(amount) {
  return `Rp ${Number(amount || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 })}`;
}

export function typeColor(t) {
  if (t === "BUY") return { text: "text-emerald-400", bg: "bg-emerald-500/15", border: "border-emerald-500/40", ring: "ring-emerald-500/50" };
  if (t === "SELL") return { text: "text-rose-400", bg: "bg-rose-500/15", border: "border-rose-500/40", ring: "ring-rose-500/50" };
  if (t === "PULSA" || t === "TELE") return { text: "text-violet-400", bg: "bg-violet-500/15", border: "border-violet-500/40", ring: "ring-violet-500/50" };
  return { text: "text-sky-400", bg: "bg-sky-500/15", border: "border-sky-500/40", ring: "ring-sky-500/50" };
}
